import { ChangeDetectorRef, Component, NgZone, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input-gg';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CustomerService } from '../customer.service';
import { Router } from '@angular/router';
import { ProfileService } from '../../profile/profile.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-customer-onboading-edit-form',
  templateUrl: './customer-onboading-edit-form.component.html',
  styleUrls: ['./customer-onboading-edit-form.component.css']
})
export class CustomerOnboadingEditFormComponent {

  imagePath: any = environment.image_path;
  imgPreview: any = "";
  customerOnBoardingForm!: FormGroup;
  addNewOfficersForm!: FormGroup;
  officersDetailsSubmitted: any = false;
  factoryDetailsSubmitted: any = false;
  bankDetailsSubmitted: any = false;
  addNewFactoryForm!: FormGroup;
  addNewBankForm!: FormGroup;
  editOfficersForm!: FormGroup;
  editFactoryForm!: FormGroup;
  editBankForm!: FormGroup;
  companyForm!: FormGroup;
  userId: any
  custId: any
  companyOfficesId: any
  companyOfficersId: any
  companyBankDetailId: any

  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  customPlaceholder: string = 'ex. 9876543210';
  private retryCount = 0;
  maxLength = 15;
  tiBussinessNature: number | null = null;
  companyData: any
  companyOfficersList: any = [];
  companyOfficesList: any = [];
  companyBankDetailsList: any = [];
  tiBussinessNatures: any
  companyType: any
  officerData: any;

  // @ViewChild('phoneInput', { static: false }) phoneInput: any;
  // @ViewChild('contactInput', { static: false }) contactInput: any;

  private observer: MutationObserver | null = null;
  private inputFields: NodeListOf<HTMLInputElement> | null = null;
  
  constructor(
    config: NgbModalConfig,
    private modalService: NgbModal,
    private notifyService: NotificationService,
    private customerService: CustomerService,
    private route: Router,
    private profileService: ProfileService,
    private cdRef: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  onboardingDetails: any = {
    vcompanyName: "",
    email: "",
    phoneNumber: "",
    contactNumber: "",
    website: "",
    faxNumber: "",
    companyAddress: "",

    vProjectAttachment: [
      { vAttachment: "" },
    ],
    companyOfficers: [],
    companyOffices: [],
    companyBankDetails: []
  };

  ngOnInit(): void {

    this.userId = localStorage.getItem("customer_UserId");

    this.customerOnBoardingForm = new FormGroup({
      profileImage: new FormControl(""),
      companyName: new FormControl("", [this.noWhitespaceValidator(), Validators.maxLength(50)]),
      email: new FormControl("", [Validators.required, Validators.email, this.noWhitespaceValidator()]),
      phoneNumber: new FormControl("", [Validators.required]),
      contactNumber: new FormControl(""),
      website: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.pattern(/^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.[a-zA-Z]{2,})(\/[a-zA-Z0-9-]*)*(\?[a-zA-Z0-9=&]*)?(#[a-zA-Z0-9-]*)?$/)]),
      faxNumber: new FormControl("", [Validators.pattern(/^(\+?\d{1,3})?[-. ]?(\(?\d{2,4}\)?)?[-. ]?\d{3,4}[-. ]?\d{3,4}$/)]),
      companyAddress: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(250)]),
      natureOfBusiness: new FormControl("", [Validators.required]),
      companyType: new FormControl("", [Validators.required]),
      years: new FormControl("", [Validators.required, Validators.pattern(/^\d{1,4}$/), Validators.maxLength(4)]),
      gstNumber: new FormControl("", [Validators.pattern("^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$")]),
      panNumber: new FormControl("", [Validators.pattern("^[A-Z]{5}[0-9]{4}[A-Z]{1}$")]),
      creaditTerms: new FormControl("", [Validators.pattern("^[a-zA-Z0-9\\s]+$"), this.noWhitespaceValidator()]),
    });

    this.editOfficersForm = new FormGroup({
      name: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      contactNumber: new FormControl("", [Validators.required]),
      designation: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(30)]),
      email: new FormControl("", [Validators.required, Validators.email, this.noWhitespaceValidator()]),
    });

    this.editFactoryForm = new FormGroup({
      firstName: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      state: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(30)]),
      contactNumber: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.required, Validators.email, this.noWhitespaceValidator()]),
      faxNumber: new FormControl("", [Validators.required, Validators.pattern(/^(\+?\d{1,3})?[-. ]?(\(?\d{2,4}\)?)?[-. ]?\d{3,4}[-. ]?\d{3,4}$/)]),
      officeAddress: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(250)]),
    });

    this.editBankForm = new FormGroup({
      bankName: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      branchName: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      bankAccountNumber: new FormControl("", [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(6), Validators.maxLength(16), this.noWhitespaceValidator()]),
      ifscNumber: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/), this.noWhitespaceValidator()]),
      ibanNumber: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/), this.noWhitespaceValidator()]),
      swiftCode: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/), this.noWhitespaceValidator()]),
      bankDocument: new FormControl(null, Validators.required)
    });

    this.addNewOfficersForm = new FormGroup({
      name: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      contactNumber: new FormControl("", [Validators.required]),
      designation: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(30)]),
      email: new FormControl("", [Validators.required, Validators.email, this.noWhitespaceValidator()]),
    });

    this.addNewFactoryForm = new FormGroup({
      firstName: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      state: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(30)]),
      contactNumber: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.required, Validators.email, this.noWhitespaceValidator()]),
      faxNumber: new FormControl("", [Validators.required, Validators.pattern(/^(\+?\d{1,3})?[-. ]?(\(?\d{2,4}\)?)?[-. ]?\d{3,4}[-. ]?\d{3,4}$/)]),
      officeAddress: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(250)]),
    });

    this.addNewBankForm = new FormGroup({
      bankName: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      branchName: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      bankAccountNumber: new FormControl("", [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(6), Validators.maxLength(16), this.noWhitespaceValidator()]),
      ifscNumber: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/), this.noWhitespaceValidator()]),
      ibanNumber: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/), this.noWhitespaceValidator()]),
      swiftCode: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/), this.noWhitespaceValidator()]),
      bankDocument: new FormControl(null, Validators.required)
    });

    this.getCustomerProfile();
    this.observeFormChanges();
  }

 
  ngAfterViewChecked() {
    if ((!this.inputFields || this.inputFields.length === 0) && this.retryCount < 10) {
      this.retryCount++;
      setTimeout(() => {
        this.findInputField();
      }, 1000);
    }
  }

  onCountryChange(event: any) {
    setTimeout(() => {
      this.inputFields = document.querySelectorAll('.iti input'); // Re-fetch all inputs
      if (this.inputFields.length) {
        this.inputFields.forEach((inputField: HTMLInputElement) => {
          this.modifyPlaceholder(inputField);
        });
      }
    }, 500);
  }

  findInputField() {
    setTimeout(() => {
      this.inputFields = document.querySelectorAll('.iti input'); // Fetch all phone input fields
  
      if (this.inputFields.length) {
        this.inputFields.forEach((inputField: HTMLInputElement) => {
          this.modifyPlaceholder(inputField);
          this.observePlaceholderChanges(inputField);
        });
      }
    }, 500); 
  }

  observePlaceholderChanges(inputField: HTMLInputElement) {
    if (!inputField) return;

    const observer = new MutationObserver(() => {
      this.modifyPlaceholder(inputField);
    });

    observer.observe(inputField, { attributes: true, attributeFilter: ['placeholder'] });

    this.modifyPlaceholder(inputField);
  }

  modifyPlaceholder(inputField: HTMLInputElement) {
    if (!inputField) return;

    const currentPlaceholder = inputField.getAttribute('placeholder');
    if (currentPlaceholder && !currentPlaceholder.startsWith('ex. ')) {
      this.ngZone.runOutsideAngular(() => {
        inputField.setAttribute('placeholder', `ex. ${currentPlaceholder}`);
      });
    }
  }

  observeFormChanges() {
    const observer = new MutationObserver(() => {
      this.findInputField(); // Re-run the logic whenever a new field appears
    });
    observer.observe(document.body, { childList: true, subtree: true }); // Watch the entire page
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  AddOfficer(modelName: any) {
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });
    this.addNewOfficersForm.reset();
  }

  EditOfficer(modelName: any, officer: any) {
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });

    this.editOfficersForm.patchValue({
      id: officer.iOfficersId,
      name: officer.vOfficerName,
      contactNumber: officer.vOfficerPhoneNo,
      designation: officer.vOfficerDesignation,
      email: officer.vOfficerEmailId,
    });
    this.companyOfficersId = officer.iOfficersId
  }

  AddBank(modelName: any) {
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });
    this.fileTypeError = false;
    this.fileName = '';
    this.selectedFiled = null;
    this.addNewBankForm.reset();
    this.addNewBankForm.reset();
  }

  EditBank(modelName: any, bank: any) {
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });
    const cleanedFileName = this.removeFakePath(bank.txChequeFile);
    this.editBankForm.patchValue({
      id: bank.iBankDetailId,
      bankName: bank.vBankName,
      branchName: bank.vBranchName,
      bankAccountNumber: bank.vBankAccNo,
      ifscNumber: bank.vIfscCode,
      ibanNumber: bank.vIbanNo,
      swiftCode: bank.vSwiftCode,
      bankDocument: cleanedFileName,
    });
    this.companyBankDetailId = bank.iBankDetailId
    this.fileName = cleanedFileName;
  }

  AddFactory(modelName: any) {
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });
    this.addNewFactoryForm.reset();
  }

  EditFactory(modelName: any, office: any) {
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });
    this.editFactoryForm.patchValue({
      id: office.iOfficeId,
      firstName: office.vOfficeName,
      state: office.vOfficeState,
      email: office.vOfficeEmailId,
      contactNumber: office.vOfficePhoneNo,
      faxNumber: office.vOfficeFaxNo,
      officeAddress: office.txOfficeAddress,
    });
    this.companyOfficesId = office.iOfficeId;
    console.log(this.companyOfficesId, "companyOfficesId");
  }

  AddNewOfficersOnSubmit() {
    this.addNewOfficersForm.markAllAsTouched();
    this.officersDetailsSubmitted = true;
    if (this.addNewOfficersForm.invalid) {
      return;
    }
    this.modalService.dismissAll();
    this.notifyService.showSuccess("Officer Added Successfully!", "");
    this.companyOfficersList.replace({
      vOfficerName: this.addNewOfficersForm.value.name,
      vOfficerDialCode: this.addNewOfficersForm.value.contactNumber.dialCode,
      vOfficerCountryCode: this.addNewOfficersForm.value.contactNumber.countryCode,
      vOfficerDesignation: this.addNewOfficersForm.value.designation,
      vOfficerPhoneNo: this.addNewOfficersForm.value.contactNumber.number,
      vOfficerEmailId: this.addNewOfficersForm.value.email
    });
  }

  AddNewFactoryOnSubmit() {
    this.addNewFactoryForm.markAllAsTouched();
    this.factoryDetailsSubmitted = true;
    if (this.addNewFactoryForm.invalid) {
      return;
    }
    this.modalService.dismissAll();
    this.notifyService.showSuccess("Factory Added Successfully!", "");
    this.onboardingDetails.companyOffices.push({
      vOfficeName: this.addNewFactoryForm.value.firstName,
      vOfficeState: this.addNewFactoryForm.value.state,
      vOfficeDialCode: this.addNewFactoryForm.value.contactNumber.dialCode,
      vOfficeCountryCode: this.addNewFactoryForm.value.contactNumber.countryCode,
      vOfficePhoneNo: this.addNewFactoryForm.value.contactNumber.number,
      vOfficeEmailId: this.addNewFactoryForm.value.email,
      vOfficeFaxNo: this.addNewFactoryForm.value.faxNumber,
      txOfficeAddress: this.addNewFactoryForm.value.officeAddress,
    });
    this.addNewFactoryForm.reset();
  }

  AddBankDetailsOnSubmit() {
    this.addNewBankForm.markAllAsTouched();
    this.bankDetailsSubmitted = true;
    if (this.addNewBankForm.invalid) {
      return;
    }
    this.modalService.dismissAll();
    this.notifyService.showSuccess("Bank Details Added Successfully!", "");
    this.onboardingDetails.companyBankDetails.push({
      vBankName: this.addNewBankForm.value.bankName,
      vBranchName: this.addNewBankForm.value.branchName,
      vBankAccNo: this.addNewBankForm.value.bankAccountNumber,
      vIfscCode: this.addNewBankForm.value.ifscNumber,
      vIbanNo: this.addNewBankForm.value.ibanNumber,
      vSwiftCode: this.addNewBankForm.value.swiftCode,
      txChequeFile: this.addNewBankForm.value.swiftCode,
    });
    this.addNewBankForm.reset();
  }

  fileName: any;
  file: File | null = null;
  fileTypeError: boolean = false;
  selectedFiled: File | null = null;


  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      // Check if the file is of type 'application/pdf'
      if (file.type !== 'application/pdf') {
        this.fileTypeError = true;
        this.fileName = '';
        this.selectedFiled = null;
        event.target.value = ''; // Clear the file input for invalid types
      } else {
        this.fileTypeError = false;
        this.fileName = file.name;
        this.selectedFiled = file;

        // Update the form control with the new file name
        this.editBankForm.patchValue({
          bankDocument: this.fileName
        });
      }
    } else {
      this.fileName = '';
      this.selectedFiled = null;
    }
  }

  uploadFile() {
    if (this.file) {
      const formData = new FormData();
      formData.append('vBankAccNo', this.file, this.file.name);
    } else {
      alert('No file selected');
    }
  }


  EditcustomerOnboardingProcess() {
    this.customerOnBoardingForm.markAllAsTouched();
    if (this.customerOnBoardingForm.invalid) {
      return;
    }

    let resData = {
      iUserId: this.userId,
      iCustOnboardId: this.custId,
      vCompanyName: this.customerOnBoardingForm.value.companyName,
      vCoEmailId: this.customerOnBoardingForm.value.email,
      vCoDialCode: this.customerOnBoardingForm.value.phoneNumber.dialCode,
      vCoCountyCode: this.customerOnBoardingForm.value.phoneNumber.countryCode,
      vCoContactDialCode: this.customerOnBoardingForm.value?.contactNumber
        ? this.customerOnBoardingForm.value.contactNumber.dialCode || ''
        : '',
      vCoContCountryCode: this.customerOnBoardingForm.value?.contactNumber
        ? this.customerOnBoardingForm.value.contactNumber.countryCode || ''
        : '',
      vCoPhoneNo: this.customerOnBoardingForm.value.phoneNumber.number,
      vCoContactNo: this.customerOnBoardingForm.value?.contactNumber
        ? this.customerOnBoardingForm.value.contactNumber.number || ''
        : '',
      txCoWebsiteLink: this.customerOnBoardingForm.value.website,
      vCoFaxNo: this.customerOnBoardingForm.value.faxNumber,
      txCompanyAddress: this.customerOnBoardingForm.value.companyAddress,
      tiBussinessNature: this.customerOnBoardingForm.value.natureOfBusiness,
      tiCompanyType: this.customerOnBoardingForm.value.companyType,
      iEstabllishmentYear: this.customerOnBoardingForm.value.years,
      vCoGstNo: this.customerOnBoardingForm.value.gstNumber,
      vCoPanNo: this.customerOnBoardingForm.value.panNumber,
      vCoCreditTerms: this.customerOnBoardingForm.value.creaditTerms,
    };

    const formData = new FormData();

    formData.append('json', JSON.stringify(resData));

    if (this.cropImgPreview) {
      const imageBlob = this.dataURItoBlob(this.cropImgPreview);
      formData.append('logo', imageBlob, 'companyLogo.png');
    }

    this.customerService.EditOnboardingForm(formData).subscribe({
      next: (result: any) => {
        if (result.code === 200) {
          this.notifyService.showSuccess(result.message, "");
          this.route.navigate(["/customer/profile"]);
          this.customerOnBoardingForm.reset();
        } else {
          this.notifyService.showError(result.message, "");
        }
      },
      error: (error: any) => {
        console.error("API Call Failed:", error);
      }
    });
  }

  dataURItoBlob(dataURI: string): Blob {
    // Ensure the data URI is correctly formatted
    if (!dataURI || !dataURI.startsWith("data:image")) {
      console.error("Invalid Data URI:", dataURI);
      return new Blob(); // Return an empty Blob if the format is incorrect
    }

    // Remove the base64 prefix (data:image/png;base64,)
    const [mimeString, base64String] = dataURI.split(',');
    if (!base64String) {
      console.error("Invalid base64 content in Data URI");
      return new Blob(); // Return an empty Blob if base64 content is missing
    }

    try {
      // Decode the base64 string
      const byteString = atob(base64String);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // Create and return the Blob with the appropriate MIME type
      const mimeType = mimeString.split(':')[1].split(';')[0];
      return new Blob([ab], { type: mimeType });

    } catch (error) {
      console.error("Error decoding base64 string:", error);
      return new Blob(); // Return an empty Blob in case of any errors
    }
  }



  currentOfficerIndex: number = -1;
  isEditMode: boolean = false;

  getCustomerProfile() {
    let reqJson = {
      // iUserId: this.custuserId
    };

    this.profileService.getCustomerProfile(reqJson).subscribe((result: any) => {
      if (result['code'] === 200) {

        const data = result['data'];
        this.custId = data.iCustOnboardId
        this.tiBussinessNatures = data.tiBussinessNature;
        this.companyOfficesList = data.CompanyOffices;
        this.companyOfficersList = data.CompanyOfficers;
        this.companyBankDetailsList = data.CompanyBankDetails;
        this.customerOnBoardingForm.patchValue({
          companyName: data.vCompanyName,
          email: data.vCoEmailId,
          phoneNumber: data.vCoPhoneNo,
          contactNumber: data.vCoContactNo,
          website: data.txCoWebsiteLink,
          faxNumber: data.vCoFaxNo,
          companyAddress: data.txCompanyAddress,
          companyType: data.tiCompanyType.toString(),
          years: data.iEstabllishmentYear,
          gstNumber: data.vCoGstNo,
          panNumber: data.vCoPanNo,
          natureOfBusiness: data.tiBussinessNature,
          creaditTerms: data.vCoCreditTerms,
        });
        this.patchProfileData(result.data);
        this.cdRef.detectChanges();
      } else {
        this.notifyService.showError(result.message, '');
      }
    });
  }

  patchProfileData(data: any) {
    this.cropImgPreview = data.txCompanyLogo;
    console.log(this.cropImgPreview);

  }

  backToOnboarding() {
    this.route.navigate(['customer/profile']);
  }


  AddNewOfficer() {
    if (this.addNewOfficersForm.invalid) {
      this.addNewOfficersForm.markAllAsTouched();
      return;
    }
    let reqJson = {
      iCustOnboardId: this.custId,
      vOfficerName: this.addNewOfficersForm.value.name,
      vOfficerEmailId: this.addNewOfficersForm.value.email,
      vOfficerPhoneNo: this.addNewOfficersForm.value.contactNumber.number,
      vOfficerDialCode: this.addNewOfficersForm.value.contactNumber.dialCode,
      vOfficerCountryCode: this.addNewOfficersForm.value.contactNumber.countryCode,
      vOfficerDesignation: this.addNewOfficersForm.value.designation,
    }
    this.customerService.AddNewOfficer(reqJson).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.notifyService.showSuccess(result.message, '');
        this.modalService.dismissAll();
        this.getCustomerProfile();
      } else {
        this.notifyService.showError(result.message, '');
      }
    })
  }

  AddNewfactory() {
    this.addNewFactoryForm.markAllAsTouched();
    if (this.addNewFactoryForm.invalid) {
      return;
    }
    let reqJson = {
      iCustOnboardId: this.custId,
      vOfficeName: this.addNewFactoryForm.value.firstName,
      vOfficePhoneNo: this.addNewFactoryForm.value.contactNumber.number,
      vOfficeDialCode: this.addNewFactoryForm.value.contactNumber.dialCode,
      vOfficeCountryCode: this.addNewFactoryForm.value.contactNumber.countryCode,
      txOfficeAddress: this.addNewFactoryForm.value.officeAddress,
      vOfficeEmailId: this.addNewFactoryForm.value.email,
      vOfficeFaxNo: this.addNewFactoryForm.value.faxNumber,
      vOfficeState: this.addNewFactoryForm.value.state,
    }

    this.customerService.AddNewfactory(reqJson).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.notifyService.showSuccess(result.message, '');
        this.modalService.dismissAll();
        this.getCustomerProfile();
      } else {
        this.notifyService.showError(result.message, '');
      }
    })
  }

  AddNewBank() {
    this.addNewBankForm.markAllAsTouched();
    if (this.addNewBankForm.invalid) {
      return;
    }
    let reqJson = {
      iCustOnboardId: this.custId,
      iUserId: this.userId,
      vBankName: this.addNewBankForm.value.bankName,
      vBranchName: this.addNewBankForm.value.branchName,
      vBankAccNo: this.addNewBankForm.value.bankAccountNumber,
      vIbanNo: this.addNewBankForm.value.ibanNumber,
      vIfscCode: this.addNewBankForm.value.ifscNumber,
      vSwiftCode: this.addNewBankForm.value.swiftCode,
    }

    const formData = new FormData();

    formData.append('json', JSON.stringify(reqJson));


    if (this.selectedFiled) {
      formData.append(this.addNewBankForm.value.bankAccountNumber, this.selectedFiled);
    }

    this.customerService.AddNewBank(formData).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.notifyService.showSuccess(result.message, '');
        this.modalService.dismissAll();
        this.getCustomerProfile();
      } else {
        this.notifyService.showError(result.message, '');
      }
    })
  }

  AddEditOfficer() {
    this.editOfficersForm.markAllAsTouched();
    if (this.editOfficersForm.invalid) {
      return;
    }
    let reqJson = {
      iOfficersId: this.companyOfficersId,
      vOfficerName: this.editOfficersForm.value.name,
      vOfficerEmailId: this.editOfficersForm.value.email,
      vOfficerPhoneNo: this.editOfficersForm.value.contactNumber.number,
      vOfficerDialCode: this.editOfficersForm.value.contactNumber.dialCode,
      vOfficerCountryCode: this.editOfficersForm.value.contactNumber.countryCode,
      vOfficerDesignation: this.editOfficersForm.value.designation,
    }
    this.customerService.AddEditOfficer(reqJson).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.notifyService.showSuccess(result.message, '');
        this.modalService.dismissAll();
        this.getCustomerProfile();
      } else {
        this.notifyService.showError(result.message, '');
      }
    })
  }

  DeleteOfficer(id: any) {
    let reqJson = {
      iOfficersId: id,
    }
    this.customerService.DeleteOfficer(reqJson).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.notifyService.showSuccess(result.message, '');
        this.modalService.dismissAll();
        this.getCustomerProfile();
      } else {
        this.notifyService.showError(result.message, '');
      }
    })
  }

  AddEditfactory() {
    this.editFactoryForm.markAllAsTouched();
    if (this.editFactoryForm.invalid) {
      return;
    }
    let reqJson = {
      iOfficeId: this.companyOfficesId,
      vOfficeName: this.editFactoryForm.value.firstName,
      vOfficePhoneNo: this.editFactoryForm.value.contactNumber.number,
      vOfficeDialCode: this.editFactoryForm.value.contactNumber.dialCode,
      vOfficeCountryCode: this.editFactoryForm.value.contactNumber.countryCode,
      txOfficeAddress: this.editFactoryForm.value.officeAddress,
      vOfficeEmailId: this.editFactoryForm.value.email,
      vOfficeFaxNo: this.editFactoryForm.value.faxNumber,
      vOfficeState: this.editFactoryForm.value.state,
    }
    this.customerService.AddEditfactory(reqJson).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.notifyService.showSuccess(result.message, '');
        this.modalService.dismissAll();
        this.getCustomerProfile();
      } else {
        this.notifyService.showError(result.message, '');
      }
    })
  }

  DeleteOffices(id: any) {
    let reqJson = {
      iOfficeId: id,
    }
    this.customerService.Deletefactory(reqJson).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.notifyService.showSuccess(result.message, '');
        this.modalService.dismissAll();
        this.getCustomerProfile();
      } else {
        this.notifyService.showError(result.message, '');
      }
    })
  }

  AddEditBank() {
    this.editBankForm.markAllAsTouched();
    if (this.editBankForm.invalid) {
      return;
    }
    let reqJson = {
      iUserId: this.userId,
      iBankDetailId: this.companyBankDetailId,
      vBankName: this.editBankForm.value.bankName,
      vBranchName: this.editBankForm.value.branchName,
      vBankAccNo: this.editBankForm.value.bankAccountNumber,
      vIbanNo: this.editBankForm.value.ibanNumber,
      vIfscCode: this.editBankForm.value.ifscNumber,
      vSwiftCode: this.editBankForm.value.swiftCode,
    }

    const formData = new FormData();

    // ✅ Use the actual file object, not just the name
    if (this.selectedFiled) {
      formData.append("txChequeFile", this.selectedFiled);
    }

    formData.append('json', JSON.stringify(reqJson));


    this.customerService.AddEditBank(formData).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.notifyService.showSuccess(result.message, '');
        this.modalService.dismissAll();
        this.getCustomerProfile();
      } else {
        this.notifyService.showError(result.message, '');
      }
    })
  }

  DeleteBankDetails(id: any) {
    let reqJson = {
      iBankDetailId: id,
    }
    this.customerService.DeleteBank(reqJson).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.notifyService.showSuccess(result.message, '');
        this.modalService.dismissAll();
        this.getCustomerProfile();
      } else {
        this.notifyService.showError(result.message, '');
      }
    })
  }

  @ViewChild('cropModal', { static: true }) cropModal: any;

  showCroppedContainer = false;
  imgChangeEvt: any = '';
  cropImgPreview: any = "";
  showEditImage = false;
  selectedFile: File | null = null;
  lastCroppedImg: any


  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
      const maxSize = 5 * 1024 * 1024; // 5MB

      const control = this.customerOnBoardingForm.get('profileImage');

      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        control?.setErrors({ invalidType: true });
        return;
      }

      // Validate file size
      if (file.size > maxSize) {
        control?.setErrors({ fileTooLarge: true });
        return;
      }

      // If validation passes, clear errors and proceed
      control?.setErrors(null);

      this.imgChangeEvt = event;  // Pass event to the cropper
      this.selectedFile = file;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.cropImgPreview = e.target.result;  // Image preview before cropping
        this.customerOnBoardingForm.patchValue({
          profileImage: this.selectedFile  // Optionally update form control
        });
      };
      reader.readAsDataURL(file);

      this.openCropModal();  // Open crop modal
    }
  }

  openCropModal() {
    this.modalService.open(this.cropModal, { centered: true, size: 'md' });
  }

  public async cropImg(e: ImageCroppedEvent) {
    if (e.blob) {
      try {
        const base64 = await this.blobToBase64(e.blob);  // Convert cropped image to base64
        this.cropImgPreview = base64;
        this.customerOnBoardingForm.patchValue({
          vProfilePhoto: base64  // Update form with the cropped image
        });
      } catch (error) {
        console.error('Error converting blob to base64:', error);
      }
    } else {
      console.error('Crop event does not contain blob data');
    }
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
    });
  }

  onCropDone(modal: any) {
    modal.close();  // Close the modal after cropping
  }

  edit() {
    this.openCropModal();  // Re-open crop modal for editing
  }

  imgLoad() {
    // Logic when image is loaded into the cropper
  }

  initCropper() {
    // Logic for initializing the cropper
  }

  imgFailed() {
    console.error('Image failed to load or crop');
  }

  closeCropperModal() {
    this.cropImgPreview = '';
    // this.croppedImage='';
    // this.profileImageFile = null;
    // this.imageChangedEvent = "";
    // this.croppedImage = "";
  }

  removeFakePath(filePath: string): string {
    if (!filePath) return '';
    return filePath.split('/').pop() || '';
  }


  hasError(form: FormGroup, controlName: string, errorName: string): boolean {
    const control = form.get(controlName);
    return !!control?.hasError(errorName) && (!!control?.touched);
  }

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const isWhitespace = (control.value || '').startsWith(' ');
      return isWhitespace ? { 'whitespace': true } : null;
    };
  }
}

